import { getErrorFromErrorResponse, isErrorResponse } from '@standardnotes/responses';
import { Result } from '@standardnotes/domain-core';
export class AcceptVaultInvite {
    constructor(inviteServer, processInvite) {
        this.inviteServer = inviteServer;
        this.processInvite = processInvite;
    }
    async execute(dto) {
        const acceptResponse = await this.inviteServer.acceptInvite({
            sharedVaultUuid: dto.invite.shared_vault_uuid,
            inviteUuid: dto.invite.uuid,
        });
        if (isErrorResponse(acceptResponse)) {
            return Result.fail(`Could not accept vault invitation: ${getErrorFromErrorResponse(acceptResponse).message}`);
        }
        await this.processInvite.execute(dto.message, dto.invite.shared_vault_uuid, dto.invite.sender_uuid);
        return Result.ok();
    }
}
